import React from 'react'
import TravelHomeSection from './TravelHomeSection'
import TravelCancellationSection from './TravelCancellationSection'
import TravelRecommendationSection from './TravelRecommendationSection'
import GuestAssistanceSection from './GuestAssistanceSection'
import HospitalitySection from './HospitalitySection'
import AIInteractions from './AIInteractions'
import TravelBrandSection from './TravelBrandSection'
import AIPlatform from './AIPlatform'

function Blogupdates() {
    return (
        <div>
            <TravelHomeSection />
            <TravelCancellationSection />
            <TravelRecommendationSection />
            <GuestAssistanceSection />
            <HospitalitySection />
            <AIPlatform />
            <AIInteractions />
            <TravelBrandSection />
        </div>
    )
}

export default Blogupdates;
